import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Display {
  id: string;
  name: string;
  status: 'online' | 'offline' | 'error';
  lastHeartbeat: string | null;
  deviceInfo: any;
  tags: string[];
}

interface DisplayState {
  items: Display[];
  selectedDisplay: Display | null;
  loading: boolean;
  error: string | null;
}

const initialState: DisplayState = {
  items: [],
  selectedDisplay: null,
  loading: false,
  error: null,
};

const displaySlice = createSlice({
  name: 'displays',
  initialState,
  reducers: {
    setDisplays: (state, action: PayloadAction<Display[]>) => {
      state.items = action.payload;
      state.loading = false;
      state.error = null;
    },
    setSelectedDisplay: (state, action: PayloadAction<Display | null>) => {
      state.selectedDisplay = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    updateDisplayStatus: (
      state,
      action: PayloadAction<{ id: string; status: string; lastHeartbeat: string }>
    ) => {
      const display = state.items.find((d) => d.id === action.payload.id);
      if (display) {
        display.status = action.payload.status as 'online' | 'offline' | 'error';
        display.lastHeartbeat = action.payload.lastHeartbeat;
      }
    },
    addDisplay: (state, action: PayloadAction<Display>) => {
      state.items.push(action.payload);
    },
    updateDisplay: (state, action: PayloadAction<Display>) => {
      const index = state.items.findIndex((d) => d.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    removeDisplay: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((d) => d.id !== action.payload);
    },
  },
});

export const {
  setDisplays,
  setSelectedDisplay,
  setLoading,
  setError,
  updateDisplayStatus,
  addDisplay,
  updateDisplay,
  removeDisplay,
} = displaySlice.actions;

export default displaySlice.reducer;
